import { Box, Select, MenuItem, FormControl, InputLabel, IconButton } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@/shared/ui/display/EmojiIcon';
import { useAdvancedSearchTheme } from '../theme/useAdvancedSearchTheme';
import type {
  SortConfig,
  SortDirection,
} from '@/shared/ui/search/AdvancedSearch/types/query.types';
import type { SortField } from '@/shared/ui/search/AdvancedSearch/types/sort.types';

interface SortControlProps {
  sortFields: readonly SortField[];
  sortConfig?: SortConfig;
  onSortChange: (config: SortConfig) => void;
}

export function SortControl({ sortFields, sortConfig, onSortChange }: SortControlProps) {
  const { sortControlSx, fieldSelectSx } = useAdvancedSearchTheme();

  const handleFieldChange = (field: string) => {
    onSortChange({
      field,
      direction: sortConfig?.direction || 'ASC',
    });
  };

  const handleDirectionToggle = () => {
    if (!sortConfig) return;

    const newDirection: SortDirection = sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    onSortChange({
      field: sortConfig.field,
      direction: newDirection,
    });
  };

  return (
    <Box sx={sortControlSx}>
      <FormControl sx={fieldSelectSx} size="small">
        <InputLabel>정렬 기준</InputLabel>
        <Select
          value={sortConfig?.field || ''}
          label="정렬 기준"
          onChange={(e) => handleFieldChange(e.target.value)}
        >
          {sortFields.map((field) => (
            <MenuItem key={field.name} value={field.name}>
              {field.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {sortConfig && (
        <IconButton
          size="small"
          onClick={handleDirectionToggle}
          title={sortConfig.direction === 'ASC' ? '오름차순' : '내림차순'}
        >
          {sortConfig.direction === 'ASC' ? <ArrowUpward /> : <ArrowDownward />}
        </IconButton>
      )}
    </Box>
  );
}
